// @flow

import React from 'react';
import {
  Box,
  Button,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

import useTourBlockoutsButton from './hooks';

// Opens the Tour Blockouts page from the Calendar tab.
const TourBlockoutsButton = () => {
  const { isShown, label, handleClick } = useTourBlockoutsButton();

  if (!isShown) return null;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
      <Button variant="primary" onClick={handleClick}>
        {label}
      </Button>
    </Box>
  );
};

export default TourBlockoutsButton;
